import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import './styles.css';
import { ShopRoot } from './app/ShopRoot.tsx';
import { ConsoleEntry } from './console/ConsoleEntry.tsx';
import { Empty } from './ui/index.tsx';

function NotFound() {
  return <div className="app"><Empty title="ไม่พบหน้านี้" text="กรุณาเปิดจากเมนูใน LINE ของร้าน" /></div>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/s/:slug/*" element={<ShopRoot />} />
        <Route path="/console/*" element={<ConsoleEntry />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
